// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"e4861c0d","939":"e4861c0d"}[chunkId] + ".chunk.css";
};